import type { MainSlider } from "~/core";

export const isMainSlider = (item: unknown): item is MainSlider => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "main_slider"
  );
};
